<template>
  <v-dialog
    ref="dialog"
    v-model="timeModal"
    persistent
    width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        v-model="formattedTime"
        :label="label"
        prepend-icon="mdi-clock-outline"
        readonly
        :error-messages="errorMessages"
        v-on="on"
      ></v-text-field>
    </template>
    <v-time-picker
      v-if="timeModal"
      v-model="time"
      :allowed-minutes="minutesInterval"
      full-width
      ampm-in-title
      @change="fieldChanged($event)"
    >
      <v-spacer></v-spacer>
      <v-btn text color="primary" @click="timeModal = false">Cancel</v-btn>
      <v-btn text color="primary" @click="$refs.dialog.save(time)">OK</v-btn>
    </v-time-picker>
  </v-dialog>
</template>

<script>
import { DateTime } from 'luxon'

export default {
  name: 'ampm-time-picker',
  props: {
    value: {
      type: String,
      required: false,
      default: null
    },
    allowedIntervalMinutes: {
      type: Number,
      required: false,
      default: 1
    },
    label: {
      type: String,
      required: false,
      default: 'Time'
    },
    errorMessages: {
      type: Array
    }
  },
  data () {
    return {
      timeModal: false
    }
  },
  computed: {
    time: {
      get () {
        return this.value
      },
      set (val) {
        this.fieldChanged(val)
      }
    },
    formattedTime () {
      try {
        this.$logger.trace('formattedTime RAW', this.value)
        const ftime = DateTime.fromFormat(this.value, 'HH:mm')
        if (!ftime.isValid) {
          return ftime.invalidReason
        } else {
          return ftime.toFormat('hh:mm a')
        }
      } catch (error) {
        this.$logger.trace('formattedTime ERROR', error)
        return ''
      }
    }
  },
  methods: {
    minutesInterval: function (v) {
      if (this.allowedIntervalMinutes === 0) return true
      return v % this.allowedIntervalMinutes === 0
    },
    fieldChanged: function (val) {
      this.$emit('change', val)
    }
  }
}
</script>
